import { render } from "./IconTruck.vue?vue&type=template&id=5a5f1ab6"
import script from "./IconTruck.vue?vue&type=script&lang=ts"
export * from "./IconTruck.vue?vue&type=script&lang=ts"
script.render = render

export default script